import React from "react";
import Login from "../layouts/Login.js";
import { useAuth } from '../../AuthContext.js';
import { useNavigate } from "react-router-dom";
import axios from "axios";

const Header = () => {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const redirigirDashBoard = async () => {
    if (!isAuthenticated) {
      navigate("/login"); // Redirigir al login si no está autenticado
      return;
    }

    const rol = localStorage.getItem("rol");
    const token = localStorage.getItem("token");
    const usuario_id = localStorage.getItem("usuario_id");

    try {
      const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/validar-sesion-rol`,
          { token, usuario_id }
      );

      if (response.status === 200 && response.data === rol) {
        switch (response.data) {
          case "ROLE_DUENO":
            navigate("/dueno");
            break;
          case "ROLE_ADMINISTRADOR":
            navigate("/administrador");
            break;
          case "ROLE_EMPLEADO":
            navigate("/empleado");
            break;
          default:
            navigate("/");
        }
      } else {
        navigate("/no-encontrado");
      }
    } catch (error) {
      navigate("/no-encontrado");
    }
  };

  return (
      <header>
        <nav
            className="navbar navbar-expand-lg fixed-top navbar-light"
            style={{ backgroundColor: '#ffd6e0' }} // rosa claro
        >
          <div className="container-fluid">
            <a className="navbar-brand" href="/">
              <img
                  src="/static/img/logo.png"
                  alt="logo de antonia depilacion"
                  draggable="false"
                  height="60"
              />
            </a>
            <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav ms-auto align-items-center">
                <li className="nav-item ms-3">
                  <button
                      type="button"
                      className={`btn ${isAuthenticated ? "btn-outline-success" : "btn-outline-primary"}`}
                      onClick={redirigirDashBoard}
                  >
                    {isAuthenticated ? "Dash Board" : "Pedir Mi Hora"}
                  </button>
                </li>
                <li className="nav-item">
                  <a className="nav-link mx-2" href="/productos">
                    <i className="fas fa-plus-circle pe-2"></i>Productos
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link mx-2" href="#!">
                    <i className="fas fa-bell pe-2"></i>Locales
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link mx-2" href="#!">
                    <i className="fas fa-heart pe-2"></i>Agenda tu hora
                  </a>
                </li>
                <li className="nav-item ms-3">
                  {isAuthenticated ? (
                      <button type="button" className="btn btn-danger" onClick={logout}>
                        Salir
                      </button>
                  ) : (
                      <button
                          type="button"
                          className="btn btn-success"
                          data-bs-toggle="modal"
                          data-bs-target="#botonInicioSesion"
                      >
                        Inicio Sesión
                      </button>
                  )}
                </li>
              </ul>
            </div>
          </div>
        </nav>
        {!isAuthenticated && <Login />}
      </header>
  );
};

export default Header;
